import { render, staticRenderFns } from "./Home.vue?vue&type=template&id=406a7e8e&scoped=true"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "406a7e8e",
  null
  
)

export default component.exports